// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"06a7a7f3","453":"1965c8d6","732":"6a4eedd1","977":"98e02e84"}[chunkId] + ".chunk.js";
};